/************************************************************************************
  Customize the application by changing the values in this file
*************************************************************************************/

import type { UserPoolScope } from "@common/domain/auth";

export interface AppConfig {
  userPoolScope: UserPoolScope;
  styledText: string;
  applicationName: string;
  companyName: string;
  shortName: string;
  appName: string;
  showHomeTab: boolean;
  showAdminTabs: boolean;
  showConversationResults?: boolean;
  showCompanionSettings: boolean;
  showResponseLengthOnly?: boolean;
  showNewChatButton: boolean;
  showGoalChecklist: boolean;
  hideChatToolsForUsersOnly: boolean;
  customTabs: Array<{ label: string; path: string; icon: string }>;
  applicationSummary: string;
  learningPersonaId?: string;
  /** Name the avatar speaks as in captions and the transcript, when it differs from the persona name. */
  avatarSpeakerName?: string;
  /** Steady two-line captions (fixed width, page turns) instead of the default tail caption. */
  steadyCaptions?: boolean;
  /** How remote avatar video fills its tile; 'contain' shows the whole frame instead of cropping. Defaults to 'cover'. */
  avatarVideoFit?: 'cover' | 'contain';
  /** Letterbox colour around the avatar video when avatarVideoFit is 'contain'. */
  avatarVideoBackground?: string;
  prodHostnames: string[];
  devHostnames: string[];
}

export const config: AppConfig = {
  // This is an application boundary, not a Cognito pool-ID lookup. Each branded
  // frontend declares the only persona pool it may present in its UI.
  userPoolScope: "lote" as const,
  styledText: "UC Irvine Elder Wisdom Platform",
  applicationName: "UC Irvine Elder Wisdom Platform",
  companyName: "Gargantua",
  shortName: "DC",
  appName: "Digital Companion",
  showHomeTab: true,
  showAdminTabs: true,
  showCompanionSettings: true,
  showResponseLengthOnly: false,
  showNewChatButton: true,
  showGoalChecklist: true,
  hideChatToolsForUsersOnly: false,
  customTabs: [],
  applicationSummary:
    "The UC Irvine Elder Wisdom Platform is an interactive portal that allows you to communicate with a digital human replica through chat and call.",
  prodHostnames: [
    process.env.REACT_APP_PROD_HOSTNAME,
    "dqq3nj4uk5onj.cloudfront.net",
    "elder-wisdom.innovation.uci.edu",
  ].filter(Boolean) as string[],
  devHostnames: [
    process.env.REACT_APP_DEV_HOSTNAME,
    "d86h32kjhatnp.cloudfront.net",
    "elder-wisdom-dev.innovation.uci.edu",
  ].filter(Boolean) as string[],
};

export const exampleQuestions = [
  "Who are you?",
  "Tell me about your childhood.",
  "Tell me about the most significant events in your life.",
];
